<template>
  <div class="LayoutDefault" id="LayoutDefault">
    <Header />
    <LeftBar id="right-side-bar" />
    <RightBar id="right-side-bar" />
    <main class="LayoutDefault__main">
      <transition name="fade">
        <slot />
      </transition>
    </main>
    <!-- <BaseLiveChat /> -->
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/layoutDefault/Header.vue";
import Footer from "@/components/layoutDefault/Footer.vue";
import RightBar from "@/components/layoutDefault/RightBar.vue";
import LeftBar from "@/components/layoutDefault/LeftBar.vue";

export default {
  data() {
    return {
      showMenu: false
    };
  },
  props: {
    name: {
      type: String,
      required: false
    }
  },
  components: {
    Header,
    Footer,
    RightBar,
    LeftBar
  },
  mounted() {
    // this.$store.dispatch("vehicles/fetchVehiclesModels");
    // eslint-disable-next-line no-console
    console.warn("LayoutDefault mounted, remove redirect later");
    this.$router.push("/dashboard");
  },
  methods: {
    toggleMenu(status) {
      this.showMenu = status;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.LayoutDefault {
  background-color: $text-clear-1;
  color: $background-body;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
